// Gravity Forms - additional functions

// Datepickers replace custom with native browser

document.addEventListener('DOMContentLoaded', () => {
	const datepickers = document.querySelectorAll('.gform-datepicker');
	datepickers.forEach(datepicker => {
		datepicker.setAttribute('type', 'date');
	});
});


// Improves scrolling after form validation, multipage navigation and submit success

document.addEventListener('gform/postRender', function (event)
{
	if (!event.detail || !event.detail.formId) return;

	const formId = event.detail.formId;
	const wrapper = document.querySelector('#gform_wrapper_' + formId);

	// Only run after a failed submission
	if (wrapper && wrapper.classList.contains('gform_validation_error'))
	{
		scrollToForm(formId);
	}
});

document.addEventListener('gform/ajax/post_page_change', function (event)
{
	// This fires on form page change and submit
	const formId = event.detail.formId;
	scrollToForm(formId);
});

function scrollToForm(formId)
{
	// Scrolls to top of form - Firefox has some issues with jumping
	const wrapper = document.querySelector('#gform_wrapper_' + formId);
	if (!wrapper) return;

	const yOffset = 60;
	const y =
		wrapper.getBoundingClientRect().top +
		window.pageYOffset -
		yOffset;

	setTimeout(() => {
		window.scrollTo({
			top: y,
			behavior: 'smooth'
		});
	}, 10);
}